import { toFilter } from './filterConverter';
import { getGlobalFilter, getProjectZoneId } from '../reducers/analyticsApp';

const getDefaultGroupColumn = (eventName) => {
  switch (eventName) {
    case 'WAU':
      return 'WEEK';
    case 'MAU':
      return 'MONTH';
    default:
      return 'DAY';
  }
};

const buildDashboardUsersQuery = (state, unit) => {
  const eventName = unit.compose.users.event;
  const usersColumns = unit.compose.users.columns.map((column) => column.value);
  const { aggregate } = unit.compose.users;

  const fieldQuery = aggregate ? 'groupBy' : 'columns';

  return {
    eventName,
    aggregations: [],
    [fieldQuery]: ['event.user_id', getDefaultGroupColumn(eventName)].concat(usersColumns),
    filter: toFilter(unit.compose.users.filter),
    globalFilter: toFilter(getGlobalFilter(state)),
    timezone: getProjectZoneId(state),
  };
};

export default buildDashboardUsersQuery;
